// 9/3/2025 Auto-link by Thuy — capped at 5 links per keyword 
/*
document.addEventListener('DOMContentLoaded', function () {
  // 1) Your keyword → URL map (case-insensitive)
  const internalLinks = [
    { keyword: "about us", url: "https://belfurniture.com/pages/about-us" },
    { keyword: "accent chair", url: "https://belfurniture.com/collections/accent-chairs" }, 
    { keyword: "accent cabinet", url: "https://belfurniture.com/collections/accent-cabinets-1" },
    { keyword: "bed frame", url: "https://belfurniture.com/collections/bed-frames" },
    { keyword: "bedroom set", url: "/collections/queen-bedrooms" },
    { keyword: "bunk beds", url: "https://belfurniture.com/collections/sturdy-bunk-beds-texas" },
    { keyword: "bunk bed", url: "/collections/kids-bunkbeds" },
    { keyword: "benches", url: "https://belfurniture.com/collections/benches" },
    { keyword: "queen bed", url: "/collections/queen-beds" },
    { keyword: "Beaumont", url: "https://belfurniture.com/pages/beaumont" },
    { keyword: "blog", url: "https://belfurniture.com/blogs/bel-blog" },
    { keyword: "barstools", url: "https://belfurniture.com/collections/bar-stools-1" },
    { keyword: "bookcases", url: "https://belfurniture.com/collections/bookcases" },
    { keyword: "chest", url: "https://belfurniture.com/collections/chests" },
    { keyword: "Clarewood", url: "https://belfurniture.com/pages/sharpstown" },
    { keyword: "coffee table", url: "https://belfurniture.com/collections/coffee-tables" },
    { keyword: "coffee tables", url: "https://belfurniture.com/collections/coffee-tables" },
    { keyword: "contact us", url: "https://belfurniture.com/pages/contact-us" },
    { keyword: "Corpus Christi", url: "https://belfurniture.com/pages/bel-furniture-south-padre-island" },
    { keyword: "Champions", url: "https://belfurniture.com/pages/champions" },
    { keyword: "Del Rio", url: "https://belfurniture.com/pages/del-rio" },
    { keyword: "desk", url: "/collections/home-office-desks-1" }, // fixed leading slash
    { keyword: "dining room set", url: "https://belfurniture.com/pages/dining-rooms" },
    { keyword: "dining table set", url: "/collections/dining-room-sets" },
     { keyword: "dining table sets", url: "/collections/dining-room-sets" },
    { keyword: "dining rooms", url: "https://belfurniture.com/pages/dining-rooms" },
    { keyword: "dining table", url: "/collections/dining-tables-1" },
    { keyword: "dresser", url: "/collections/dressers" },
    { keyword: "end table", url: "https://belfurniture.com/collections/end-tables" },
    { keyword: "extra firm", url: "https://belfurniture.com/collections/mattresses-extra-firm" },
    { keyword: "entertainment center", url: "/collections/entertainment-centers-2" },
    { keyword: "entertainment centers", url: "/collections/entertainment-centers-2" },
    { keyword: "file cabinets", url: "/collections/file-cabinets" },
    { keyword: "fireplace", url: "/collections/fireplaces" },
    { keyword: "firm mattresses", url: "https://belfurniture.com/collections/mattresses-firm" },
    { keyword: "full mattress", url: "/collections/mattress-full" },
    { keyword: "home decor", url: "https://belfurniture.com/pages/home-decor" },
    { keyword: "home office", url: "https://belfurniture.com/pages/home-office" },
    { keyword: "home office furniture", url: "https://belfurniture.com/collections/home-office-desks-1" },
    { keyword: "Houston", url: "https://belfurniture.com/pages/sharpstow" },
    { keyword: "Humble", url: "https://belfurniture.com/pages/humble" },
    { keyword: "hybrid mattresses", url: "https://belfurniture.com/collections/hybrid-mattresses" },
    { keyword: "kids furniture", url: "https://belfurniture.com/pages/kids-furniture-store-houston" },
    { keyword: "kids' furniture", url: "https://belfurniture.com/pages/kids-furniture-store-houston" },
    { keyword: "king mattress", url: "/collections/mattresses-king" },
    { keyword: "Katy", url: "https://belfurniture.com/pages/katy-tx-furniture-store-bel" },
    { keyword: "lamp", url: "https://belfurniture.com/collections/lamp" },
    { keyword: "Lake Jackson", url: "https://belfurniture.com/pages/lake-jackson-showroom" },
    { keyword: "lighting", url: "https://belfurniture.com/collections/lamp" },
    { keyword: "living room set", url: "https://belfurniture.com/collections/stationary-living-room-set" },
    { keyword: "locations", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "loveseat", url: "https://belfurniture.com/collections/loveseat" },
    { keyword: "futons", url: "https://belfurniture.com/collections/day-beds-futons" },
    { keyword: "innerspring", url: "https://belfurniture.com/collections/mattresses-innerspring" }, 
    { keyword: "mattresses", url: "https://belfurniture.com/pages/mattresses" }, 
    { keyword: "mattress", url: "https://belfurniture.com/pages/mattresses" }, 
    { keyword: "medium firm", url: "https://belfurniture.com/collections/mattresses-medium" },  
    { keyword: "memory foam", url: "/collections/affordable-memory-foam-mattresses-texas" },
    { keyword: "memory foam mattress", url: "/collections/affordable-memory-foam-mattresses-texas" },
    { keyword: "modular sectional", url: "https://belfurniture.com/collections/modular-sectionals" },
    { keyword: "nightstands", url: "/collections/nightstands" },
    { keyword: "office chair", url: "/collections/home-office-chairs" },
    { keyword: "online", url: "https://belfurniture.com" },
    { keyword: "outdoor patio set", url: "/collections/patio-outdoor-seating-set" },
    { keyword: "ottoman", url: "https://belfurniture.com/collections/upholstered-ottomans" },    
    { keyword: "Pasadena", url: "https://belfurniture.com/pages/pasadena" },
    { keyword: "queen mattress", url: "/collections/mattress-queen" },
    { keyword: "recliners", url: "/collections/recliners-for-sale-in-texas" },
    { keyword: "rug", url: "https://belfurniture.com/collections/rugs-living-room" },
    { keyword: "area rugs", url: "https://belfurniture.com/collections/rugs-living-room" },
    { keyword: "San Antonio", url: "https://belfurniture.com/pages/san-antonio-showroom" },
    { keyword: "showrooms", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "sofas", url: "/collections/stationary-sofas" },
    { keyword: "sofa", url: "/collections/sofa" },
    { keyword: "sofa beds", url: "https://belfurniture.com/collections/day-beds-futons" },
    { keyword: "side tables", url: "https://belfurniture.com/collections/end-tables" },
    { keyword: "stationary sectional", url: "/collections/stationary-sectionals" },
    { keyword: "sectional", url: "https://belfurniture.com/collections/sectionals" },
    { keyword: "sectional sofas", url: "https://belfurniture.com/collections/sectionals" },
    { keyword: "sectional sofa", url: "https://belfurniture.com/collections/sectionals" },
    { keyword: "store locator", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "stores", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "Sugar Land", url: "https://belfurniture.com/pages/sugarland" },
    { keyword: "Spring", url: "https://belfurniture.com/pages/spring" },
    { keyword: "TV stand", url: "/collections/tv-stands" },
    { keyword: "twin mattress", url: "/collections/mattress-twin" },
    { keyword: "vanity set", url: "https://belfurniture.com/collections/vanities" },
    { keyword: "Victoria", url: "https://belfurniture.com/pages/victoria" }
  ];

  // 2) Helper: escape regex specials
  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // 3) Build a lookup (lowercased) and a single combined regex, longest keywords first
  const map = new Map();
  internalLinks.forEach(({ keyword, url }) => map.set(keyword.toLowerCase(), url));
  const sortedKeywords = [...map.keys()].sort((a, b) => b.length - a.length);
  const pattern = `(?<![\\p{L}\\p{N}_-])(${sortedKeywords.map(escapeRegExp).join('|')})(?![\\p{L}\\p{N}_-])`;
  const matcher = new RegExp(pattern, 'giu');

  // 4) Scope: only main content (avoid nav/footer/headers/reviews)
  const scope = document.querySelector('[data-autolink-scope]') || document.querySelector('main') || document.body;

  // 5) Skip on product pages if desired
  const isProductPage = () =>
    window.location.pathname.startsWith('/products/') || document.body.classList.contains('template-product');
  if (isProductPage()) return;

  // 6) Walk text nodes and replace with <a>… only if not already inside a link or forbidden tags
  const forbidden = new Set(['A', 'SCRIPT', 'STYLE', 'NOSCRIPT', 'H1', 'H2', 'H3']);
  const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const p = node.parentNode;
      if (!p || forbidden.has(p.nodeName)) return NodeFilter.FILTER_REJECT;
      // Also skip if any ancestor is an <a>
      let el = p;
      while (el) {
        if (el.nodeName === 'A') return NodeFilter.FILTER_REJECT;
        el = el.parentNode;
      }
      // Skip empty/whitespace-only nodes
      if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }
  });

  // === Per-paragraph cap (1 per keyword) ===
  // Track counts per nearest block container (paragraph-like element)
  const perBlockCounts = new WeakMap(); // Element -> Map<keywordLower, count>

  // Which tags are considered "block/paragraph" containers
  const BLOCK_TAGS = new Set([
    'P','LI','DD','DT','FIGCAPTION','BLOCKQUOTE','TD','TH','DIV','SECTION','ARTICLE'
  ]);

  function getBlockContainer(startEl) {
    let el = startEl;
    while (el && el !== scope) {
      if (BLOCK_TAGS.has(el.nodeName)) return el;
      el = el.parentElement;
    }
    return startEl; // fallback
  }

  const nodesToProcess = [];
  while (walker.nextNode()) nodesToProcess.push(walker.currentNode);

  nodesToProcess.forEach(textNode => {
    const original = textNode.nodeValue;
    let changed = false;

    // Find the nearest block container for this text node
    const blockEl = getBlockContainer(textNode.parentElement || textNode.parentNode);
    let blockMap = perBlockCounts.get(blockEl);
    if (!blockMap) {
      blockMap = new Map();
      perBlockCounts.set(blockEl, blockMap);
    }

    const html = original.replace(matcher, (match) => {
      const key = match.toLowerCase();
      const url = map.get(key);
      if (!url) return match;

      // Cap per paragraph: max 1 per keyword
      const used = blockMap.get(key) || 0;
      if (used >= 1) return match;

      blockMap.set(key, used + 1);
      changed = true;
      return `<a href="${url}">${match}</a>`;
    });

    if (changed) {
      const span = document.createElement('span');
      span.innerHTML = html;
      textNode.parentNode.replaceChild(span, textNode);
    }
  });

});*/
document.addEventListener('DOMContentLoaded', function () {
  // 1) Keyword → URL map
  const internalLinks = [
    { keyword: "about us", url: "https://belfurniture.com/pages/about-us" },
    { keyword: "accent chair", url: "https://belfurniture.com/collections/accent-chairs" }, 
    { keyword: "accent cabinet", url: "https://belfurniture.com/collections/accent-cabinets-1" },
    { keyword: "accent pillows", url: "/collections/throw-pillows" },
    { keyword: "bed frame", url: "https://belfurniture.com/collections/bed-frames" },
    { keyword: "bedroom set", url: "/collections/queen-bedrooms" },
    { keyword: "bedroom", url: "https://belfurniture.com/pages/bedroom-furniture-sets-texas" },
    { keyword: "bunk beds", url: "https://belfurniture.com/collections/sturdy-bunk-beds-texas" },
    { keyword: "bunk bed", url: "/collections/kids-bunkbeds" },
    { keyword: "benches", url: "https://belfurniture.com/collections/benches" },
    { keyword: "queen bed", url: "/collections/queen-beds" },
    { keyword: "Beaumont", url: "https://belfurniture.com/pages/beaumont" },
    { keyword: "blog", url: "https://belfurniture.com/blogs/bel-blog" },
    { keyword: "barstools", url: "https://belfurniture.com/collections/bar-stools-1" },
    { keyword: "bookcases", url: "https://belfurniture.com/collections/bookcases" },
    { keyword: "chest", url: "/collections/chests" },
    { keyword: "Clarewood", url: "https://belfurniture.com/pages/sharpstown" },
    { keyword: "coffee table", url: "https://belfurniture.com/collections/coffee-tables" },
    { keyword: "coffee tables", url: "https://belfurniture.com/collections/coffee-tables" },
    { keyword: "contact us", url: "https://belfurniture.com/pages/contact-us" },
    { keyword: "Corpus Christi", url: "https://belfurniture.com/pages/bel-furniture-south-padre-island" },
    { keyword: "Champions", url: "https://belfurniture.com/pages/champions" },
    { keyword: "chairs", url: "https://belfurniture.com/collections/accent-chairs" },
    { keyword: "chair", url: "https://belfurniture.com/collections/accent-chairs" },
    { keyword: "Del Rio", url: "https://belfurniture.com/pages/del-rio" },
    { keyword: "desk", url: "/collections/home-office-desks-1" },
    { keyword: "dining room set", url: "https://belfurniture.com/pages/dining-rooms" },
    { keyword: "dining sets", url: "/collections/dining-room-sets" },
    { keyword: "dining table set", url: "/collections/dining-room-sets" },
    { keyword: "dining table sets", url: "/collections/dining-room-sets" },
    { keyword: "dining rooms", url: "https://belfurniture.com/pages/dining-rooms" },
    { keyword: "dining table", url: "/collections/dining-tables-1" },
    { keyword: "dresser", url: "/collections/dressers" },
    { keyword: "end table", url: "https://belfurniture.com/collections/end-tables" },
    { keyword: "extra firm", url: "https://belfurniture.com/collections/mattresses-extra-firm" },
    { keyword: "entertainment center", url: "/collections/entertainment-centers-2" },
    { keyword: "entertainment centers", url: "/collections/entertainment-centers-2" },
    { keyword: "file cabinets", url: "/collections/file-cabinets" },
    { keyword: "fireplace", url: "/collections/fireplaces" },
    { keyword: "firm mattresses", url: "https://belfurniture.com/collections/mattresses-firm" },
    { keyword: "full mattress", url: "/collections/mattress-full" },
    { keyword: "home decor", url: "https://belfurniture.com/pages/home-decor" },
    { keyword: "home office", url: "https://belfurniture.com/pages/home-office" },
    { keyword: "home office furniture", url: "https://belfurniture.com/collections/home-office-desks-1" },
    { keyword: "Houston", url: "https://belfurniture.com/pages/sharpstown" },
    { keyword: "Humble", url: "https://belfurniture.com/pages/humble" },
    { keyword: "hybrid mattresses", url: "https://belfurniture.com/collections/hybrid-mattresses" },
    { keyword: "kids furniture", url: "https://belfurniture.com/pages/kids-furniture-store-houston" },
    { keyword: "kids' furniture", url: "https://belfurniture.com/pages/kids-furniture-store-houston" },
    { keyword: "king mattress", url: "/collections/mattresses-king" },
    { keyword: "Katy", url: "https://belfurniture.com/pages/katy-tx-furniture-store-bel" },
    { keyword: "lamp", url: "https://belfurniture.com/collections/lamp" },
    { keyword: "Lake Jackson", url: "https://belfurniture.com/pages/lake-jackson-showroom" },
    { keyword: "lighting", url: "https://belfurniture.com/collections/lamp" },
    { keyword: "living room set", url: "https://belfurniture.com/collections/stationary-living-room-set" },
    { keyword: "living room", url: "https://belfurniture.com/pages/texas-living-room-furniture-store" },
    { keyword: "locations", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "loveseat", url: "https://belfurniture.com/collections/loveseat" },
    { keyword: "futons", url: "https://belfurniture.com/collections/day-beds-futons" },
    { keyword: "innerspring", url: "https://belfurniture.com/collections/mattresses-innerspring" }, 
    { keyword: "mattresses", url: "https://belfurniture.com/pages/mattresses" }, 
    { keyword: "mattress", url: "https://belfurniture.com/pages/mattresses" }, 
    { keyword: "medium firm", url: "https://belfurniture.com/collections/mattresses-medium" },  
    { keyword: "memory foam", url: "/collections/affordable-memory-foam-mattresses-texas" },
    { keyword: "memory foam mattress", url: "/collections/affordable-memory-foam-mattresses-texas" },
    { keyword: "modular sectional", url: "https://belfurniture.com/collections/modular-sectionals" },
    { keyword: "nightstands", url: "/collections/nightstands" },
    { keyword: "office chair", url: "/collections/home-office-chairs" },
    { keyword: "online", url: "https://belfurniture.com" },
    { keyword: "outdoor patio set", url: "/collections/patio-outdoor-seating-set" },
    { keyword: "ottoman", url: "https://belfurniture.com/collections/upholstered-ottomans" },    
    { keyword: "Pasadena", url: "https://belfurniture.com/pages/pasadena" },
    { keyword: "queen mattress", url: "/collections/mattress-queen" },
    { keyword: "recliners", url: "/collections/recliners-for-sale-in-texas" },
    { keyword: "rug", url: "https://belfurniture.com/collections/rugs-living-room" },
    { keyword: "rugs", url: "https://belfurniture.com/collections/rugs-living-room" },
    { keyword: "area rugs", url: "https://belfurniture.com/collections/rugs-living-room" },
    { keyword: "San Antonio", url: "https://belfurniture.com/pages/san-antonio-showroom" },
    { keyword: "showrooms", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "sofas", url: "/collections/stationary-sofas" },
    { keyword: "sofa", url: "/collections/sofa" },
    { keyword: "sofa beds", url: "https://belfurniture.com/collections/day-beds-futons" },
    { keyword: "side tables", url: "https://belfurniture.com/collections/end-tables" },
    { keyword: "stationary sectional", url: "/collections/stationary-sectionals" },
    { keyword: "sectional", url: "https://belfurniture.com/collections/sectionals" },
    { keyword: "sectional sofas", url: "https://belfurniture.com/collections/sectionals" },
    { keyword: "sectional sofa", url: "https://belfurniture.com/collections/sectionals" },
    { keyword: "store locator", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "stores", url: "https://belfurniture.com/pages/store-locator-archive" },
    { keyword: "Sugar Land", url: "https://belfurniture.com/pages/sugarland" },
    { keyword: "Spring", url: "https://belfurniture.com/pages/spring" },
    { keyword: "TV stand", url: "/collections/tv-stands" },
    { keyword: "twin mattress", url: "/collections/mattress-twin" },
    { keyword: "vanity set", url: "https://belfurniture.com/collections/vanities" },
    { keyword: "Victoria", url: "https://belfurniture.com/pages/victoria" }
  ];

  // 2) Regex builder
  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const map = new Map();
  internalLinks.forEach(({ keyword, url }) => map.set(keyword.toLowerCase(), url));
  const sortedKeywords = [...map.keys()].sort((a, b) => b.length - a.length);
  const pattern = `(?<![\\p{L}\\p{N}_-])(${sortedKeywords.map(escapeRegExp).join('|')})(?![\\p{L}\\p{N}_-])`;
  const matcher = new RegExp(pattern, 'giu');

  // 3) Scope
  const scope = document.querySelector('[data-autolink-scope]') || document.querySelector('main') || document.body;

  // 4) Skip product pages
  const isProductPage = () =>
    window.location.pathname.startsWith('/products/') || document.body.classList.contains('template-product');
  if (isProductPage()) return;

  // 5) TreeWalker with heading/opt-out skip
  const forbiddenTags = new Set(['A','SCRIPT','STYLE','NOSCRIPT']);
  function isInsideHeading(el) {
    return !!(el && el.closest && el.closest('h1,h2,h3,h4,h5,h6,[role="heading"]'));
  }
  function isInsideOptOut(el) {
    return !!(el && el.closest && el.closest('.no-autolink,[data-autolink="off"]'));
  }

  const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const p = node.parentNode;
      if (!p) return NodeFilter.FILTER_REJECT;
      if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
      if (forbiddenTags.has(p.nodeName)) return NodeFilter.FILTER_REJECT;

      // skip if inside a link
      let el = p;
      while (el) {
        if (el.nodeName === 'A') return NodeFilter.FILTER_REJECT;
        el = el.parentNode;
      }

      // skip if inside heading or opt-out area
      if (isInsideHeading(p)) return NodeFilter.FILTER_REJECT;
      if (isInsideOptOut(p)) return NodeFilter.FILTER_REJECT;

      return NodeFilter.FILTER_ACCEPT;
    }
  });

  // 6) Per-block cap
  const perBlockCounts = new WeakMap();
  const BLOCK_TAGS = new Set(['P','LI','DD','DT','FIGCAPTION','BLOCKQUOTE','TD','TH','DIV','SECTION','ARTICLE']);
  function getBlockContainer(startEl) {
    let el = startEl;
    while (el && el !== scope) {
      if (BLOCK_TAGS.has(el.nodeName)) return el;
      el = el.parentElement;
    }
    return startEl;
  }

  const nodesToProcess = [];
  while (walker.nextNode()) nodesToProcess.push(walker.currentNode);

  nodesToProcess.forEach(textNode => {
    const original = textNode.nodeValue;
    let changed = false;
    const blockEl = getBlockContainer(textNode.parentElement || textNode.parentNode);
    let blockMap = perBlockCounts.get(blockEl);
    if (!blockMap) {
      blockMap = new Map();
      perBlockCounts.set(blockEl, blockMap);
    }

    const html = original.replace(matcher, (match) => {
      const key = match.toLowerCase();
      const url = map.get(key);
      if (!url) return match;
      const used = blockMap.get(key) || 0;
      if (used >= 1) return match;
      blockMap.set(key, used + 1);
      changed = true;
    //return `<a href="${url}">${match}</a>`;
    return `<a class="autolink" href="${url}" style="color:inherit;">${match}</a>`;
    
    });

    if (changed) {
      const span = document.createElement('span');
      span.innerHTML = html;
      textNode.parentNode.replaceChild(span, textNode);
    }
  });

  // 7) Optional cleanup: remove any existing links in headings
  document.querySelectorAll('h1 a, h2 a, h3 a, h4 a, h5 a, h6 a, [role="heading"] a').forEach(a => {
    const txt = document.createTextNode(a.textContent);
    a.replaceWith(txt);
  });

});




